import React from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import {
  Login,
  ForgotPassword,
  ResetPassword,
  Page404,
  Dashboard,
  Franchise,
  UserList,
  UserAdd,
  UserEdit,
  UserDetail,
  StoreList,
  StoreAdd,
  StoreEdit,
  StoreDetail,
  ProductList,
  ProductAdd,
  ProductEdit,
  ProductDetail,
  ProductOrderList,
  CategoryList,
  CategoryAdd,
  CategoryEdit,
  ServiceList,
  ServiceAdd,
  ServiceEdit,
  ProviderList,
  ProviderAdd,
  ProviderEdit,
  ProviderDetail,
  CustomerList,
  CustomerDetail,
  EmployeeList,
  EmployeeAdd,
  EmployeeEdit,
  EmployeeDetail,
  DailyBalance,
  DailyBalanceDetail,
  EmployeesBalance,
  DetailedReport,
  CategoryBalance,
  PaymentBalance,
  ReceiptBalance,
  OfferBalance,
  ServiceBalance,
  DaysBalance,
  CustomersBalance,
  ProductBalance,
  ProductsIn,
  InternalConsumption,
  Regularizations,
  ProductsDevolutions,
  Inventory,
  OfferAdd,
  OfferEdit,
  OfferDetail,
  OfferList,
  QuotationList,
  QuotationDetail,
  QuotationAdd,
  QuotationEdit,
  RemoteSells,
  RewardList,
  CustomerResetPassword,
  NewsletterList,
  NewsletterAdd,
  NewsletterEdit,
  NewsletterDetail,
  ContactUs,
} from "../scenes";
import { PrivateMainLayoutRoute } from "../components";
import { roles } from "../common/constants";

export default () => {
  return (
    <BrowserRouter>
      <Switch>
        <Redirect exact from="/" to="/dashboard" />

        <Route exact path="/login" component={Login} />
        <Route exact path="/forgotpassword" component={ForgotPassword} />
        <Route exact path="/resetpassword" component={ResetPassword} />
        <Route
          exact
          path="/customer/resetpassword"
          component={CustomerResetPassword}
        />
        <Route exact path="/contactanos" component={ContactUs} />

        <PrivateMainLayoutRoute exact path="/dashboard" component={Dashboard} />
        <PrivateMainLayoutRoute
          exact
          path="/franchise"
          component={Franchise}
          allowedRoles={[roles.SUPER_ADMIN, roles.ACCOUNTANT]}
        />

        <PrivateMainLayoutRoute
          exact
          path="/administration/users"
          component={UserList}
        />
        <PrivateMainLayoutRoute
          exact
          path="/administration/users/add"
          component={UserAdd}
        />
        <PrivateMainLayoutRoute
          exact
          path="/administration/users/:id/edit"
          component={UserEdit}
        />
        <PrivateMainLayoutRoute
          exact
          path="/administration/users/:id/detail"
          component={UserDetail}
        />

        <PrivateMainLayoutRoute
          exact
          path="/administration/stores"
          component={StoreList}
        />
        <PrivateMainLayoutRoute
          exact
          path="/administration/stores/add"
          component={StoreAdd}
          allowedRoles={[roles.SUPER_ADMIN]}
        />
        <PrivateMainLayoutRoute
          exact
          path="/administration/stores/:id/edit"
          component={StoreEdit}
          allowedRoles={[roles.SUPER_ADMIN]}
        />
        <PrivateMainLayoutRoute
          exact
          path="/administration/stores/:id/detail"
          component={StoreDetail}
        />

        <PrivateMainLayoutRoute
          exact
          path="/administration/products"
          component={ProductList}
        />
        <PrivateMainLayoutRoute
          exact
          path="/administration/products/add"
          component={ProductAdd}
          allowedRoles={[roles.SUPER_ADMIN]}
        />
        <PrivateMainLayoutRoute
          exact
          path="/administration/products/:id/edit"
          component={ProductEdit}
          allowedRoles={[roles.SUPER_ADMIN]}
        />
        <PrivateMainLayoutRoute
          exact
          path="/administration/products/:id/detail"
          component={ProductDetail}
        />
        <PrivateMainLayoutRoute
          exact
          path="/administration/products/:id/orders"
          component={ProductOrderList}
          allowedRoles={[roles.SUPER_ADMIN, roles.ADMIN]}
        />

        <PrivateMainLayoutRoute
          exact
          path="/administration/categories"
          component={CategoryList}
        />
        <PrivateMainLayoutRoute
          exact
          path="/administration/categories/add"
          component={CategoryAdd}
          allowedRoles={[roles.SUPER_ADMIN]}
        />
        <PrivateMainLayoutRoute
          exact
          path="/administration/categories/:id/edit"
          component={CategoryEdit}
          allowedRoles={[roles.SUPER_ADMIN]}
        />

        <PrivateMainLayoutRoute
          exact
          path="/administration/services"
          component={ServiceList}
        />
        <PrivateMainLayoutRoute
          exact
          path="/administration/services/add"
          component={ServiceAdd}
          allowedRoles={[roles.SUPER_ADMIN]}
        />
        <PrivateMainLayoutRoute
          exact
          path="/administration/services/:id/edit"
          component={ServiceEdit}
          allowedRoles={[roles.SUPER_ADMIN]}
        />

        <PrivateMainLayoutRoute
          exact
          path="/administration/providers"
          component={ProviderList}
        />
        <PrivateMainLayoutRoute
          exact
          path="/administration/providers/add"
          component={ProviderAdd}
          allowedRoles={[roles.SUPER_ADMIN]}
        />
        <PrivateMainLayoutRoute
          exact
          path="/administration/providers/:id/edit"
          component={ProviderEdit}
          allowedRoles={[roles.SUPER_ADMIN]}
        />
        <PrivateMainLayoutRoute
          exact
          path="/administration/providers/:id/detail"
          component={ProviderDetail}
        />

        <PrivateMainLayoutRoute
          exact
          path="/administration/rewards"
          component={RewardList}
        />

        <PrivateMainLayoutRoute
          exact
          path="/administration/newsletters"
          component={NewsletterList}
        />
        <PrivateMainLayoutRoute
          exact
          path="/administration/newsletters/add"
          component={NewsletterAdd}
        />
        <PrivateMainLayoutRoute
          exact
          path="/administration/newsletters/:id/edit"
          component={NewsletterEdit}
        />
        <PrivateMainLayoutRoute
          exact
          path="/administration/newsletters/:id/detail"
          component={NewsletterDetail}
        />

        <PrivateMainLayoutRoute
          exact
          path="/administration/customers"
          component={CustomerList}
        />
        <PrivateMainLayoutRoute
          exact
          path="/administration/customers/:id/detail"
          component={CustomerDetail}
        />

        <PrivateMainLayoutRoute
          exact
          path="/administration/employees"
          component={EmployeeList}
        />
        <PrivateMainLayoutRoute
          exact
          path="/administration/employees/add"
          component={EmployeeAdd}
        />
        <PrivateMainLayoutRoute
          exact
          path="/administration/employees/:id/edit"
          component={EmployeeEdit}
        />
        <PrivateMainLayoutRoute
          exact
          path="/administration/employees/:id/detail"
          component={EmployeeDetail}
        />

        <PrivateMainLayoutRoute
          exact
          path="/report/dailybalance"
          component={DailyBalance}
        />
        <PrivateMainLayoutRoute
          exact
          path="/report/dailybalance/:id/detail"
          component={DailyBalanceDetail}
        />
        {/* <PrivateMainLayoutRoute
          exact
          path="/report/employeesbalance"
          component={EmployeesBalance}
        /> */}
        <PrivateMainLayoutRoute
          exact
          path="/report/detailedreport"
          component={DetailedReport}
        />
        <PrivateMainLayoutRoute
          exact
          path="/report/receiptbalance"
          component={ReceiptBalance}
          allowedRoles={[roles.SUPER_ADMIN, roles.ADMIN, roles.ACCOUNTANT]}
        />
        <PrivateMainLayoutRoute
          exact
          path="/report/categorybalance"
          component={CategoryBalance}
          allowedRoles={[roles.SUPER_ADMIN, roles.ADMIN, roles.ACCOUNTANT]}
        />
        <PrivateMainLayoutRoute
          exact
          path="/report/paymentbalance"
          component={PaymentBalance}
          allowedRoles={[roles.SUPER_ADMIN, roles.ADMIN, roles.ACCOUNTANT]}
        />
        <PrivateMainLayoutRoute
          exact
          path="/report/servicebalance"
          component={ServiceBalance}
          allowedRoles={[roles.SUPER_ADMIN, roles.ADMIN, roles.ACCOUNTANT]}
        />
        <PrivateMainLayoutRoute
          exact
          path="/report/daysbalance"
          component={DaysBalance}
          allowedRoles={[roles.SUPER_ADMIN, roles.ADMIN, roles.ACCOUNTANT]}
        />
        <PrivateMainLayoutRoute
          exact
          path="/report/customersbalance"
          component={CustomersBalance}
          allowedRoles={[roles.SUPER_ADMIN, roles.ADMIN, roles.ACCOUNTANT]}
        />
        <PrivateMainLayoutRoute
          exact
          path="/report/productbalance"
          component={ProductBalance}
          allowedRoles={[roles.SUPER_ADMIN, roles.ADMIN, roles.ACCOUNTANT]}
        />
        <PrivateMainLayoutRoute
          exact
          path="/report/offerbalance"
          component={OfferBalance}
          allowedRoles={[roles.SUPER_ADMIN, roles.ADMIN, roles.ACCOUNTANT]}
        />

        <PrivateMainLayoutRoute
          exact
          path="/report/productsin"
          component={ProductsIn}
          allowedRoles={[roles.SUPER_ADMIN, roles.ADMIN, roles.ACCOUNTANT]}
        />
        <PrivateMainLayoutRoute
          exact
          path="/report/internalconsumption"
          component={InternalConsumption}
          allowedRoles={[roles.SUPER_ADMIN, roles.ADMIN, roles.ACCOUNTANT]}
        />
        <PrivateMainLayoutRoute
          exact
          path="/report/regularizations"
          component={Regularizations}
          allowedRoles={[roles.SUPER_ADMIN, roles.ADMIN, roles.ACCOUNTANT]}
        />
        <PrivateMainLayoutRoute
          exact
          path="/report/productsdevolutions"
          component={ProductsDevolutions}
          allowedRoles={[roles.SUPER_ADMIN, roles.ADMIN, roles.ACCOUNTANT]}
        />
        <PrivateMainLayoutRoute
          exact
          path="/report/inventory"
          component={Inventory}
          allowedRoles={[roles.SUPER_ADMIN, roles.ADMIN, roles.ACCOUNTANT]}
        />

        <PrivateMainLayoutRoute
          exact
          path="/administration/offers"
          component={OfferList}
        />
        <PrivateMainLayoutRoute
          exact
          path="/administration/offers/add"
          component={OfferAdd}
          allowedRoles={[roles.SUPER_ADMIN]}
        />
        <PrivateMainLayoutRoute
          exact
          path="/administration/offers/:id/edit"
          component={OfferEdit}
          allowedRoles={[roles.SUPER_ADMIN]}
        />
        <PrivateMainLayoutRoute
          exact
          path="/administration/offers/:id/detail"
          component={OfferDetail}
        />

        <PrivateMainLayoutRoute
          exact
          path="/administration/quotations"
          component={QuotationList}
        />
        <PrivateMainLayoutRoute
          exact
          path="/administration/quotations/add"
          component={QuotationAdd}
        />
        <PrivateMainLayoutRoute
          exact
          path="/administration/quotations/:id/edit"
          component={QuotationEdit}
        />
        <PrivateMainLayoutRoute
          exact
          path="/administration/quotations/:id/detail"
          component={QuotationDetail}
        />

        <PrivateMainLayoutRoute
          exact
          path="/remotesells"
          component={RemoteSells}
        />

        <Route component={Page404} />
      </Switch>
    </BrowserRouter>
  );
};



// WEBPACK FOOTER //
// ./src/router/index.js